import { Card, Col, Row } from 'antd';
import { FC } from 'react';
import { UseRentStatisticsResult } from '../../rents/dashboard/useRentStatistics';
import Chart from 'react-apexcharts';

const colors = [
  '#C903FF',
  '#0010F7',
  '#1BE7FF',
  '#FFC700',
  '#111314',
  '#FF0022',
];
function getChartOption(
  entry: UseRentStatisticsResult['top5Customers'][number],
  total: number,
  index: number,
) {
  const percentage = Math.round((100 * entry.value) / total);

  let colorsIndex = index % colors.length;
  const color = colors[colorsIndex];
  return {
    title: entry.description,
    value: `${percentage}%`,
    labels: [entry.description],
    chart: {
      type: 'radialBar',
      series: [percentage],
      height: 22,
      width: 24,
      options: {
        grid: {
          show: false,
          padding: {
            left: -15,
            right: -15,
            top: -12,
            bottom: -15,
          },
        },
        colors: [color],
        plotOptions: {
          radialBar: {
            labels: {
              show: true,
              name: {
                fontSize: '1rem',
              },
            },

            hollow: {
              size: '20%',
            },
            track: {
              background: '#DFE6E9',
            },
            dataLabels: {
              showOn: 'always',
              name: {
                show: false,
              },
              value: {
                show: false,
              },
            },
          },
        },
        stroke: {
          lineCap: 'round',
        },
      },
    },
  } as any;
}

const Customer: FC<{
  customer: UseRentStatisticsResult['top5Customers'][number];
  total: number;
  index: number;
}> = ({ customer, total, index }) => {
  const chartOption = getChartOption(customer, total, index);
  return (
    <div key={chartOption.title}>
      <Row justify='space-between' className='hp-mt-32'>
        <Col span={12}>
          <Row>
            <p className='hp-p1-body hp-mb-0'>{chartOption.title}</p>
          </Row>
        </Col>
        <Col className='hp-text-right' span={12}>
          <Row justify='end'>
            <p className='hp-badge-text hp-mb-0 hp-mr-8 hp-align-self-center'>
              {chartOption.value}
            </p>
            <Chart
              options={chartOption.chart.options}
              series={chartOption.chart.series}
              type={chartOption.chart.type}
              height={chartOption.chart.height}
              width={chartOption.chart.width}
            />
          </Row>
        </Col>
      </Row>
    </div>
  );
};

const CustomersRanking: FC<{
  customers: UseRentStatisticsResult['top5Customers'];
}> = ({ customers }) => {
  const total = customers.reduce((prev, curr) => prev + curr.value, 0);
  return (
    <>
      {customers.map((customer, index) => (
        <Customer total={total} customer={customer} index={index} />
      ))}
    </>
  );
};
const TopCustomersCard: FC<{
  statistics: UseRentStatisticsResult['top5Customers'];
}> = ({ statistics }) => {
  return (
    <Card className='hp-border-color-black-40 hp-card-6 hp-eCommerceCardOne'>
      <Row>
        <Col span={24}>
          <Row justify='space-between' align='middle'>
            <h5 className='hp-mb-0 hp-font-weight-600'>Top 5 clientes</h5>
          </Row>
        </Col>

        <Col span={24}>{<CustomersRanking customers={statistics} />}</Col>
      </Row>
    </Card>
  );
};

export default TopCustomersCard;
